const randomkey=()=>{
  let key="";
  const characters = "abcdefghijklmnopqrstuvwxyz0123456789";
  for (let i = 0; i < 12; i++) {
    key += characters[Math.floor(Math.random() * characters.length)];
    if (key.length == 12) {
      return key;
    }
  }
}
export default randomkey;
